import React from 'react';

const IPFSImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ src, ...props }) => {

  let uri = src;

  if (src?.indexOf('ipfs://') === 0) {
    uri = `https://gateway.pinata.cloud/ipfs/${src.substring('ipfs://'.length)}`;
  }

  return <img {...props} src={uri} />;
};

export default IPFSImage;
